import createIcon from '../../createIcon';

/**
 * @component @name EmergencyRecording
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggMTAuNDhWNkMxOCA0LjkgMTcuMSA0IDE2IDRINEMyLjkgNCAyIDQuOSAyIDZWMThDMiAxOS4xIDIuOSAyMCA0IDIwSDE2QzE3LjEgMjAgMTggMTkuMSAxOCAxOFYxMy41MkwyMiAxNy41VjYuNUwxOCAxMC40OFpNMTIgMTJMMTUgMTMuNzNMMTQgMTUuNDZMMTEgMTMuNzNWMTdIOVYxMy43M0w2IDE1LjQ2TDUgMTMuNzNMOCAxMkw1IDEwLjI3TDYgOC41NEw5IDEwLjI3VjdIMTFWMTAuMjdMMTQgOC41NEwxNSAxMC4yN0wxMiAxMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const EmergencyRecording = createIcon('EmergencyRecording', [
  [
    'path',
    {
      d: 'M18 10.48V6C18 4.9 17.1 4 16 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H16C17.1 20 18 19.1 18 18V13.52L22 17.5V6.5L18 10.48ZM12 12L15 13.73L14 15.46L11 13.73V17H9V13.73L6 15.46L5 13.73L8 12L5 10.27L6 8.54L9 10.27V7H11V10.27L14 8.54L15 10.27L12 12Z',
      key: 'mdaazc',
    },
  ],
]);

export default EmergencyRecording;
